import ReorderHandle from './reorder-handle.element.js';

export default ReorderHandle;

ReorderHandle.define('wje-reorder-handle', ReorderHandle);
